module.exports = __webpack_public_path__ + "static/media/Primary_Amex.28b88724.svg";